export default __webpack_public_path__ + "static/media/bg-pattern-two-circles.daeea6c5.svg";